export default (state: $TSFixMe) => state;
